import { isTracingEnabled } from '../config'

export function appTrace(message?: any, ...optionalParams: any[]) {
  if (!isTracingEnabled()) return
  console.log(message, ...optionalParams)
}
